import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface SpecAccordionProps {
  specs: Array<{ label: string; value: string }>;
}

/**
 * docs/ui/component-inventory.md `SpecAccordion`: key-value technical specs,
 * multi-open (a buyer comparing a laptop's RAM against its battery life
 * shouldn't have to reopen one section to check the other). Starts fully
 * expanded — these are short values a buyer is actively deciding on, not
 * FAQ-length content worth hiding by default.
 */
export function SpecAccordion({ specs }: SpecAccordionProps) {
  return (
    <Accordion type="multiple" defaultValue={specs.map((_, index) => `spec-${index}`)}>
      {specs.map((spec, index) => (
        <AccordionItem key={spec.label} value={`spec-${index}`}>
          <AccordionTrigger>{spec.label}</AccordionTrigger>
          <AccordionContent>{spec.value}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
